export default __webpack_public_path__ + "resources/icons/n212-cab8.png";